/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ComponentFilter {
  base = "base",
  fixed = "fixed",
  frame = "frame",
  stone = "stone",
}

export enum CutFilter {
  cabochon = "cabochon",
  faceted = "faceted",
}

export enum MaterialFilter {
  ceramic = "ceramic",
  diamonds = "diamonds",
  rosegold = "rosegold",
  whitegold = "whitegold",
  yellowgold = "yellowgold",
}

export enum ProductGroupFilter {
  bracelet = "bracelet",
  earring = "earring",
  necklace = "necklace",
  ring = "ring",
}

export enum SizeFilter {
  large = "large",
  medium = "medium",
  small = "small",
}

export enum StyleFilter {
  classic = "classic",
  hippiechic = "hippiechic",
  onepiece = "onepiece",
  oval = "oval",
  twin = "twin",
}

export enum SubStyleFilter {
  earring_base_1212 = "earring_base_1212",
  earring_base_ajour = "earring_base_ajour",
  earring_base_animal = "earring_base_animal",
  earring_base_bohemian = "earring_base_bohemian",
  earring_base_capsule = "earring_base_capsule",
  earring_base_diamonds_0709 = "earring_base_diamonds_0709",
  earring_base_evening_plain_diamonds = "earring_base_evening_plain_diamonds",
  earring_base_galaxy = "earring_base_galaxy",
  earring_base_geo = "earring_base_geo",
  earring_base_hippie_flower = "earring_base_hippie_flower",
  earring_base_hippie_leaf = "earring_base_hippie_leaf",
  earring_base_hippie_pearsh = "earring_base_hippie_pearsh",
  earring_base_hippie_pearshape = "earring_base_hippie_pearshape",
  earring_base_hippie_python = "earring_base_hippie_python",
  earring_base_hippie_star = "earring_base_hippie_star",
  earring_base_link = "earring_base_link",
  earring_base_mini_0808 = "earring_base_mini_0808",
  earring_base_plain_diamonds = "earring_base_plain_diamonds",
  earring_base_raindrop = "earring_base_raindrop",
  earring_base_simplicity = "earring_base_simplicity",
  earring_base_simplicity_diamonds = "earring_base_simplicity_diamonds",
  ring_base_0808 = "ring_base_0808",
  ring_base_1212 = "ring_base_1212",
  ring_base_1318 = "ring_base_1318",
  ring_base_1622 = "ring_base_1622",
  ring_base_1818 = "ring_base_1818",
  ring_base_ajour_1212 = "ring_base_ajour_1212",
  ring_base_ajour_1318 = "ring_base_ajour_1318",
  ring_base_ajour_1622 = "ring_base_ajour_1622",
  ring_base_ajour_1818 = "ring_base_ajour_1818",
  ring_base_ceramic_1818 = "ring_base_ceramic_1818",
  ring_base_core_1212 = "ring_base_core_1212",
  ring_base_core_1622 = "ring_base_core_1622",
  ring_base_curl_long_0709 = "ring_base_curl_long_0709",
  ring_base_diamonds_0709 = "ring_base_diamonds_0709",
  ring_base_diamonds_1818 = "ring_base_diamonds_1818",
  ring_base_stiletto_0709 = "ring_base_stiletto_0709",
  ring_base_stiletto_0808 = "ring_base_stiletto_0808",
  ring_base_twist_0808 = "ring_base_twist_0808",
}

export interface CheckoutAddressInput {
  first_name: string
  last_name: string
  company_name?: string | null
  phone_number?: string | null
  line_1: string
  line_2?: string | null
  city: string
  postcode: string
  county: string
  country: string
}

export interface CheckoutCustomerInput {
  email: string
  name: string
}

export interface CreateCartArticleInput {
  id: string
  quantity: number
  price?: number | null
  size?: string | null
}

export interface NewsletterSignupInput {
  firstName: string
  lastName: string
  email: string
}

export interface PaymentDetailsInput {
  paymentData: string
  MD: string
  PaRes: string
}

export interface PaymentGiftcardInput {
  giftcardNumber: string
  securityCode: string
  amount: number
}

export interface PaymentInput {
  amount: number
  orderId: string
  paymentMethod?: any | null
  returnUrl: string
  giftcard?: PaymentGiftcardInput | null
  paypalOrderId?: string | null
  shopperIP?: string | null
  browserInfo?: any | null
}

export interface ReturnProductsInput {
  orderNumber: string
  productIds: string[]
  reason: string
  changeFor?: string | null
  name: string
  email: string
  comment?: string | null
}

export interface ValidateGiftCardInput {
  giftcardNumber: string
  securityCode: string
}

export interface WarrantySignupInput {
  firstName: string
  lastName: string
  email: string
  purchaseDate: string
}

//==============================================================
// END Enums and Input Objects
//==============================================================
